import styled from 'styled-components';
import { Link } from 'view/common/analytics/link';
import { ThemedButton } from 'view/common/themed-button';
import * as bp from 'view/styles/breakpoints';
import * as grid from 'view/styles/grid';
import * as mixins from 'view/styles/mixins';
import * as zIndex from 'view/styles/z-index';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { SEARCH_BAR_HEIGHT } from '../search-bar';

export const StyledContainer = styled.div`
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    width: 100vw;
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
`;

export const SearchResultContainer = styled.div`
    display: flex;
    height: 100%;
    justify-content: center;
    background-color: ${token('elevation.surface.overlay', colors.N0)};
    z-index: ${zIndex.searchBar - 1};
    top: ${SEARCH_BAR_HEIGHT};
    /*
        We disable pointer events for the parent container of search
        so we can click through into the blanket to close the modal
     */
    pointer-events: none;
    overflow-y: auto;
    /* Enables smooth scrolling on mobile devices (chrome/safari) */
    --webkit-overflow-scrolling: touch;
`;

export const SectionResultContainer = styled.div`
    position: relative;
    top: ${SEARCH_BAR_HEIGHT};
    display: flex;
    flex-flow: column;
    max-width: 90vw;
    width: 100%;
    padding: ${token('space.100', '8px')};
    box-sizing: border-box;
    pointer-events: auto;
    ${bp.fromMedium.css`
    max-width: 50vw;
    `};
`;

export const Title = styled.h4`
    ${mixins.clamp};
    margin: 0;
    font-weight: normal;
`;

export const Snippet = styled.p`
    color: ${token('color.text', colors.N800)};
    margin-top: ${token('space.100', '8px')};
    padding-right: ${token('space.200', '16px')};
    ${mixins.multiLineClamp(3, 20)};
`;

export const LinkContainer = styled(Link)`
    display: flex;
    border-radius: ${token('border.radius.100', '3px')};
    ${mixins.raiseUpOnHoverOrFocus()};
    background-color: ${token('elevation.surface.raised', colors.N0)};
    padding: ${token('space.200', '16px')};
    margin: ${token('space.100', '8px')} 0 0;
    &:hover,
    &:focus {
        background: ${token('elevation.surface.raised', colors.N0)};
        text-decoration: none;
    }
    &:hover h3,
    &:focus h3 {
        color: ${(props) => token('color.link', props.theme.color)};
    }
`;

export const ResultItemContainer = styled.div`
    display: flex;
    flex-flow: column;
    width: 100%;
    padding: 0 ${token('space.100', '16px')};
    box-sizing: border-box;
    pointer-events: auto;
`;

//@ts-ignore TypeScript upgrade 5.1.6, please fix this violation.
export const StyledThemedButton = styled(ThemedButton)`
    margin-left: auto;
    margin-right: auto;
`;

export const StyledImage = styled.img`
    width: ${token('space.300', '24px')};
    height: ${token('space.300', '24px')};
    object-fit: contain;
`;

export const ResultTitleContainer = styled.h6`
    padding-top: ${token('space.200', '16px')};
    margin-top: ${token('space.0', '0px')};
    text-transform: uppercase;
`;

export const FilterContainer = styled.div`
    display: flex;
    justify-content: left;
    position: relative;
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
    left: 5vw;
    top: ${SEARCH_BAR_HEIGHT};
    height: ${token('space.400', '32px')};
    padding-top: ${token('space.200', '16px')};
    padding-bottom: ${token('space.100', '8px')};
    padding-left: ${token('space.050', '4px')};
    background-color: ${token('elevation.surface.overlay', colors.N0)};
    z-index: ${zIndex.searchBar};
    ${bp.fromMedium.css`
    /* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
        left: 25vw;
    `};
`;

// error/none styles
export const Root = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    max-width: ${grid.multiple(70).px};
    padding: ${token('space.400', '32px')} ${token('space.100', '8px')} ${token('space.100', '8px')}
        ${token('space.100', '8px')};
`;

export const MessageTitle = styled.div`
    text-align: center;
    font-weight: bold;
    padding: ${token('space.200', '16px')} 0;
`;

export const HelperText = styled.div`
    text-align: center;
`;

export const Img = styled.img`
    width: ${token('space.1000', '80px')};
    padding: ${token('space.200', '16px')};
`;
